import Discard from '../../../assets/discard.svg';

const DiscardIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Discard {...props} />;
};

export default DiscardIcon;
